import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {PickingListDeliveryState} from "@/interfaces/state";
import {IdMapper} from "@/interfaces/state/base";
import {Lading, PickingListDelivery} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import store from "@/store";
import { union } from "lodash";
import {PickingListDeliveryEmployeeParams} from "@/modules/pickinglistdeliveries/params";
import {
    deletePickingListDelivery,
    listBillLadingByPickingListDeliveryId,
    listPickingListDeliveryForEmployee, listPickingListDeliveryForPartner,
    singlePickingListDelivery
} from "@/modules/pickinglistdeliveries/services";
import {LadingStore} from "@/modules/ladings/store";
import {getDataSequentiallyV2} from "@/shared/services/helper/utils";

@Module({ dynamic: true, name: "pickingListDelivery", store })
class PickingListDeliveryModule extends VuexModule implements PickingListDeliveryState {
    data: IdMapper<PickingListDelivery> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: any = new PickingListDeliveryEmployeeParams();

    @Mutation
    private MAP_PICKING_LIST_DELIVERIES(payload: any) {
        const idMapper: IdMapper<PickingListDelivery> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((pickingList: PickingListDelivery) => {
            idMapper[pickingList.id] = pickingList;
            return pickingList.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_PICKING_LIST_DELIVERY(payload: PickingListDelivery) {
        if (!payload) return;
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = {
            ...this.data[payload.id] || {},
            ...payload
        };
    }

    @Mutation
    private REMOVE_PICKING_LIST_DELIVERY(payload: number) {
        this.ids.splice(this.ids.indexOf(payload), 1);
    }

    @Mutation
    private UPDATE_PICKING_LIST_DELIVERY_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private SET_BILL_LADINGS_INTO_PICKING_LIST_DELIVERY({ id, billLadings }) {
        if (this.data[id]) {
            this.data[id] = { ...this.data[id], billLadings }
        }
        billLadings.forEach((billLading: Lading) => LadingStore.addLading(billLading));
    }

    @Mutation
    private CLEAR_PICKING_LIST_DELIVERYS() {
        this.ids = [];
        this.data = {};
    }

    @Action({ rawError: true })
    public updatePickingListDeliveryParams(payload: any) {
        this.UPDATE_PICKING_LIST_DELIVERY_PARAMS(payload);
    }

    @Action({ rawError: true })
    public async listPickingListDeliveryForEmployee(payload: any) {
        const { data } = await listPickingListDeliveryForEmployee(payload);
        this.MAP_PICKING_LIST_DELIVERIES(data);
    }

    @Action({ rawError: true })
    public async listPickingListDeliveryForPartner(payload: any) {
        const { data } = await listPickingListDeliveryForPartner(payload);
        this.MAP_PICKING_LIST_DELIVERIES(data);
    }

    @Action({ rawError: true })
    public async singlePickingListDelivery(payload: any) {
        const { data } = await singlePickingListDelivery(payload);
        this.ADD_PICKING_LIST_DELIVERY(data.data);
    }

    @Action({ rawError: true })
    public async listBillLadingByPickingListDelivery(payload: any) {
        const billLadings = await getDataSequentiallyV2(listBillLadingByPickingListDeliveryId, { page: 1, limit: 50 }, payload);
        this.SET_BILL_LADINGS_INTO_PICKING_LIST_DELIVERY({ id: payload, billLadings: billLadings });
    }

    @Action({ rawError: true })
    public addPickingListDelivery(payload: any) {
        this.ADD_PICKING_LIST_DELIVERY(payload);
    }

    @Action({ rawError: true })
    public clearPickingListDelivery() {
        this.CLEAR_PICKING_LIST_DELIVERYS();
    }

    @Action({ rawError: true })
    public async deletePickingListDelivery(payload: number) {
        await deletePickingListDelivery(payload);
        this.REMOVE_PICKING_LIST_DELIVERY(payload);
    }
}

export const PickingListDeliveryStore = getModule(PickingListDeliveryModule);
